module.exports = "<div class=input-group moment-picker=$ctrl.datepicker min-date=$ctrl.minDate max-date=$ctrl.maxDate validate=$ctrl.validate start-date=$ctrl.startDate change=\"$ctrl.onDateChanged(newValue, oldValue)\"><input class=gmc-form-control ng-disabled=$ctrl.disabled ng-class=\"$ctrl.warn ? 'warn' : ''\" ng-attr-placeholder={{::$ctrl.placeholder}} ng-model=$ctrl.datepicker ng-change=$ctrl.datePicked() ng-model-options=\"{ updateOn: 'blur' }\"> <span class=gmc-date-picker-btn><i class=\"fa fa-calendar\"></i></span></div>";


//////////////////
// WEBPACK FOOTER
// ./app/shared/components/gmc-date-picker/gmc-date-picker.component.html
// module id = 837
// module chunks = 31